import { useEffect, useState } from "react";
import { Collapse, ListGroup } from "react-bootstrap";
import { FaFolder, FaList, FaPlay } from "react-icons/fa6";
import { cdiscManagementService } from "../../APIServices/CDISC/cdiscManagementService";
import { useParams } from "react-router";

function CDISCManagementSidebar({ handleAddNewTab, checkActiveTab, collapseSidebar, openModule, runOutput }) {
  const [openResultLibrary, setOpenResultLibrary] = useState(false);
  const [openSDTM, setOpenSDTM] = useState(false);
  const [openAnalysis, setOpenAnalysis] = useState(false);
  const [SDTMList, setSDTMList] = useState([]);
  const [anallysisList, setAnallysisList] = useState([]);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  let { studyId } = useParams();


  const getStudyCDISCOutputLibraryData = async () => {
    let data = await cdiscManagementService.getStudyCDISCOutputLibraryData(studyId, StudyMode)
    let result = data?.data || []
    let SDTMList = result?.filter(item => item.type === "sdtm")
    setSDTMList(SDTMList)
    let anallysisList = result?.filter(item => item.type === "analysis")
    setAnallysisList(anallysisList)
  }

  useEffect(() => {
    getStudyCDISCOutputLibraryData();
  }, [runOutput]);

  return (
    <>
      <div className="sidebar" id="myGroup">
        <div className="menus">
          {openModule === "cdiscStudy" && (
            <ListGroup className="w-100">
              <ListGroup.Item className={`border-0 border-bottom bg-light`} style={{ padding: "6px 0px 6px 15px" }}>
                <div className="hstack justify-content-between w-100">
                  <span className="fw-bold hstack" style={{ height: 18 }}>
                    <FaFolder className="me-2" />
                    {!collapseSidebar && <span>Study Management</span>}
                  </span>
                </div>
              </ListGroup.Item>
              <ListGroup className="rounded-0 overflow-auto" style={{ height: "calc(100vh - 144px)" }}>
                <ListGroup.Item action
                  className={`border-0 border-bottom ${checkActiveTab("studyDetail") && "selectedMenu"}`}
                  style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "25px"}` }}
                  onClick={() => { handleAddNewTab("Study Details", "fa-solid fa-clipboard-list", "studyDetail") }}
                  title={"Study Details"}
                >
                  <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
                  {!collapseSidebar && <span>Study Details</span>}
                </ListGroup.Item>
                <ListGroup.Item action
                  className={`border-0 border-bottom ${checkActiveTab("auditLogs") && "selectedMenu"}`}
                  style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "25px"}` }}
                  onClick={() => { handleAddNewTab("Audit Logs", "fa-solid fa-clipboard-list", "auditLogs") }}
                  title={"Audit Logs"}
                >
                  <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
                  {!collapseSidebar && <span>Audit Logs</span>}
                </ListGroup.Item>
              </ListGroup>
            </ListGroup>
          )}
          {openModule === "cdiscMetadata" && (
            <ListGroup className="w-100">
              <ListGroup.Item className={`border-0 border-bottom bg-light`} style={{ padding: "6px 0px 6px 15px" }}>
                <div className="hstack justify-content-between w-100">
                  <span className="fw-bold hstack" style={{ height: 18 }}>
                    <FaList className="me-2" />
                    {!collapseSidebar && <span>Metadata Management</span>}
                  </span>
                </div>
              </ListGroup.Item>
              <ListGroup className="rounded-0 overflow-auto" style={{ height: "calc(100vh - 144px)" }}>
                <ListGroup.Item action
                  className={`border-0 border-bottom ${checkActiveTab("CLookup") && "selectedMenu"}`}
                  style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "25px"}` }}
                  onClick={() => { handleAddNewTab("C-Lookup", "fa-solid fa-database", "CLookup") }}
                  title={"C-Lookup"}
                >
                  <div className="hstack justify-content-between w-100">
                    <span>
                      <i className={`fa-solid fa-database me-2`}></i>
                      {!collapseSidebar && <span>C-Lookup</span>}
                    </span>
                  </div>
                </ListGroup.Item>
                <ListGroup.Item action
                  className={`border-0 border-bottom ${checkActiveTab("CMap") && "selectedMenu"}`}
                  style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "25px"}` }}
                  onClick={() => { handleAddNewTab("C-Map", "fa-solid fa-database", "CMap") }}
                  title={"C-Map"}
                >
                  <div className="hstack justify-content-between w-100">
                    <span>
                      <i className={`fa-solid fa-database me-2`}></i>
                      {!collapseSidebar && <span>C-Map</span>}
                    </span>
                  </div>
                </ListGroup.Item>
                <ListGroup.Item action
                  className={`border-0 border-bottom ${checkActiveTab("TMap") && "selectedMenu"}`}
                  style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "25px"}` }}
                  onClick={() => { handleAddNewTab("T-Map", "fa-solid fa-database", "TMap") }}
                  title={"T-Map"}
                >
                  <div className="hstack justify-content-between w-100">
                    <span>
                      <i className={`fa-solid fa-database me-2`}></i>
                      {!collapseSidebar && <span>T-Map</span>}
                    </span>
                  </div>
                </ListGroup.Item>
                <ListGroup.Item action
                  className={`border-0 border-bottom ${checkActiveTab("cdiscSDA") && "selectedMenu"}`}
                  style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "25px"}` }}
                  onClick={() => { handleAddNewTab("SDA", "fa-solid fa-database", "cdiscSDA") }}
                  title={"SDA"}
                >
                  <div className="hstack justify-content-between w-100">
                    <span>
                      <i className={`fa-solid fa-database me-2`}></i>
                      {!collapseSidebar && <span>SDA</span>}
                    </span>
                  </div>
                </ListGroup.Item>
                <ListGroup.Item action
                  className={`border-0 border-bottom ${checkActiveTab("formLibrary") && "selectedMenu"}`}
                  style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "25px"}` }}
                  onClick={() => { handleAddNewTab("Form Management", "fa-solid fa-database", "formLibrary") }}
                  title={"Form Management"}
                >
                  <div className="hstack justify-content-between w-100">
                    <span>
                      <i className={`fa-solid fa-database me-2`}></i>
                      {!collapseSidebar && <span>Form Management</span>}
                    </span>
                  </div>
                </ListGroup.Item>
                <ListGroup.Item action
                  className={`border-0 border-bottom ${checkActiveTab("formDataLibrary") && "selectedMenu"}`}
                  style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "25px"}` }}
                  onClick={() => { handleAddNewTab("Data Management", "fa-solid fa-database", "formDataLibrary") }}
                  title={"Data Management"}
                >
                  <div className="hstack justify-content-between w-100">
                    <span>
                      <i className={`fa-solid fa-database me-2`}></i>
                      {!collapseSidebar && <span>Data Management</span>}
                    </span>
                  </div>
                </ListGroup.Item>
                <ListGroup.Item action
                  className={`border-0 border-bottom ${checkActiveTab("trialDesignManagement") && "selectedMenu"}`}
                  style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "25px"}` }}
                  onClick={() => { handleAddNewTab("Trial Design", "fa-solid fa-database", "trialDesignManagement") }}
                  title={"Trial Design"}
                >
                  <div className="hstack justify-content-between w-100">
                    <span>
                      <i className={`fa-solid fa-database me-2`}></i>
                      {!collapseSidebar && <span>Trial Design</span>}
                    </span>
                  </div>
                </ListGroup.Item>
              </ListGroup>
            </ListGroup>
          )}
          {openModule === "cdiscRunOutput" && (
            <>
              <ListGroup className="w-100">
                <ListGroup.Item className={`border-0 border-bottom bg-light`} style={{ padding: "6px 0px 6px 15px" }}>
                  <div className="hstack justify-content-between w-100">
                    <span className="fw-bold hstack" style={{ height: 18 }}>
                      <FaPlay className="me-2" />
                      {!collapseSidebar && <span>Run and Output</span>}
                    </span>
                  </div>
                </ListGroup.Item>
                <ListGroup className="rounded-0 overflow-auto" style={{ height: "calc(100vh - 144px)" }}>
                  <ListGroup.Item action
                    className={`border-0 border-bottom ${checkActiveTab("finalDomain") && "selectedMenu"}`}
                    style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "25px"}` }}
                    onClick={() => { handleAddNewTab("Final Domain", "fa-solid fa-database", "finalDomain") }}
                    title={"Final Domain"}
                  >
                    <div className="hstack justify-content-between w-100">
                      <span>
                        <i className={`fa-solid fa-database me-2`}></i>
                        {!collapseSidebar && <span>Final Domain</span>}
                      </span>
                    </div>
                  </ListGroup.Item>
                  <ListGroup.Item action
                    className={`border-0 border-bottom ${openResultLibrary && "bg-light"}`}
                    style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "22px"}` }}
                    onClick={() => setOpenResultLibrary(!openResultLibrary)}
                  >
                    <div className="hstack justify-content-between w-100">
                      <span>
                        <i className={`fa-solid fa-${openResultLibrary ? "folder-open" : "folder"} me-2`}></i>
                        {!collapseSidebar && <span>Result Library</span>}
                      </span>
                      <span>
                        <i className={`fa-solid fa-angle-${openResultLibrary ? "down" : "right"}`}></i>
                      </span>
                    </div>
                  </ListGroup.Item>
                  <Collapse in={openResultLibrary === true}>
                    <div>
                      <ListGroup.Item action
                        className={`border-0 border-bottom ${openSDTM && "bg-light"}`}
                        style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                        onClick={() => setOpenSDTM(!openSDTM)}
                      >
                        <div className="hstack justify-content-between w-100">
                          <span>
                            <i className={`fa-solid fa-${openSDTM ? "folder-open" : "folder"} me-2`}></i>
                            {!collapseSidebar && <span>SDTM</span>}
                          </span>
                          <span>
                            <i className={`fa-solid fa-angle-${openSDTM ? "down" : "right"}`}></i>
                          </span>
                        </div>
                      </ListGroup.Item>
                      <Collapse in={openSDTM === true}>
                        <div>
                          {SDTMList?.map((item, index) => (
                            <ListGroup.Item key={index} action
                              className={`border-0 border-bottom ${checkActiveTab(`resultLibrary_${item?.uniqueId}`) && "selectedMenu"}`}
                              style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "45px"}` }}
                              onClick={() => { handleAddNewTab(item?.name, "fa-solid fa-database", `resultLibrary_${item?.uniqueId}`, { url: item?.url }) }}
                              title={item?.name}
                            >
                              <div className="hstack justify-content-between w-100">
                                <span>
                                  <i className={`fa-solid fa-database me-2`}></i>
                                  {!collapseSidebar && <span>{item?.name}</span>}
                                </span>
                              </div>
                            </ListGroup.Item>
                          ))}
                        </div>
                      </Collapse>
                      <ListGroup.Item action
                        className={`border-0 border-bottom ${openAnalysis && "bg-light"}`}
                        style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                        onClick={() => setOpenAnalysis(!openAnalysis)}
                      >
                        <div className="hstack justify-content-between w-100">
                          <span>
                            <i className={`fa-solid fa-${openAnalysis ? "folder-open" : "folder"} me-2`}></i>
                            {!collapseSidebar && <span>Analysis</span>}
                          </span>
                          <span>
                            <i className={`fa-solid fa-angle-${openAnalysis ? "down" : "right"}`}></i>
                          </span>
                        </div>
                      </ListGroup.Item>
                      <Collapse in={openAnalysis === true}>
                        <div>
                          {anallysisList?.map((item, index) => (
                            <ListGroup.Item key={index} action
                              className={`border-0 border-bottom ${checkActiveTab(`resultLibrary_${item?.uniqueId}`) && "selectedMenu"}`}
                              style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "45px"}` }}
                              onClick={() => { handleAddNewTab(item?.name, "fa-solid fa-database", `resultLibrary_${item?.uniqueId}`, { url: item?.url }) }}
                              title={item?.name}
                            >
                              <div className="hstack justify-content-between w-100">
                                <span>
                                  <i className={`fa-solid fa-database me-2`}></i>
                                  {!collapseSidebar && <span>{item?.name}</span>}
                                </span>
                              </div>
                            </ListGroup.Item>
                          ))}
                        </div>
                      </Collapse>
                    </div>
                  </Collapse>
                </ListGroup>
              </ListGroup>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default CDISCManagementSidebar;
